import React, { useState } from 'react';
import MainImage from '../../images/portfolio/PulverHeksa/thumbnail.png';

import PortfolioPage from '../../components/PortfolioPage';
import { useT } from '../../i18n';

const PortfolioCreaza = () => {
    const t = useT();

    const [showVideo, setShowVideo] = useState(false);

    const onVideoSelect = (videoUrl) => {
      setShowVideo(videoUrl)
    }
    return <PortfolioPage
        img={MainImage}
        url="https://www.youtube.com/watch?v=XiBqVDDwZnA"
        externalLink={true}
        title={t("Pulverheksas Magiske Jul", "Pulverheksas Magiske Jul (The Powder Witch's Magical Christmas)")}
        description={t(
            <>
                <p>
                    Pulverheksas magiske jul er en animert film, basert på noen av de populære bøkene om Pulverheksa av Ingunn Aamodt.
                    Filmen er for hele familien, og spesielt tilpasset det minste publikummet.
                </p>
                <br />
                <p>(2024)</p>
                <br />
                <p>
                    På dette prosjektet ble vi hyret inn av Verdiverkstedet for å gjøre karakteranimasjon.
                    Vi jobbet med alle karakterene i serien, og sto for 20 minutter av karakteranimasjonen totalt.
                    Programmet vi brukte var ToonBoom Harmony.
                </p>
            </>,
            <>
                <p>
                    Pulverheksas magiske jul is an animated film based on some of Ingunn Aamodt's popular books about Pulverheksa (the Powder Witch).
                    The film is for the whole family, and especially suited to the youngest viewers.
                </p>
                <br />
                <p>(2024)</p>
                <br />
                <p>
                    Verdiverkstedet hired us to do character animation on this project.
                    We worked on all the characters in the series and delivered 20 minutes of character animation in total.
                    We worked in Toon Boom Harmony.
                </p>
            </>
        )}
    >
    </PortfolioPage>

}

export default PortfolioCreaza;
